import { render, staticRenderFns } from "./CatalogTable.vue?vue&type=template&id=ea0278ce&scoped=true"
import script from "./CatalogTable.vue?vue&type=script&lang=ts"
export * from "./CatalogTable.vue?vue&type=script&lang=ts"
import style0 from "./CatalogTable.vue?vue&type=style&index=0&id=ea0278ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0278ce",
  null
  
)

export default component.exports